import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';


const headCells = [
  { id: 'buttons', numeric: true, disablePadding: false, label: <strong></strong> },
  { id: 'identifier', numeric: true, disablePadding: false, label: <strong>Nome</strong> },
  { id: 'active', numeric: true, disablePadding: false, label: <strong>Status</strong> },
  { id: 'date', numeric: true, disablePadding: false, label: <strong>Alertas</strong> },
  { id: 'battery', numeric: true, disablePadding: false, label: <strong>Bateria</strong> },
  { id: 'route_progress', numeric: true, disablePadding: true, label: <strong>Progresso</strong> },
  { id: 'taken_at', numeric: true, disablePadding: false, label: <strong>Últimas Atualizações</strong> },
  { id: 'arow', numeric: true, disablePadding: false, label: <strong></strong> }
];

export default function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align='left'
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
